import React from 'react';

export const SkipLink = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-6 focus:py-3 focus:bg-[#1d4ed8] focus:text-white focus:rounded-full focus:shadow-lg focus:outline-none focus:ring-4 focus:ring-[#1d4ed8] focus:ring-offset-2"
      data-testid="skip-link"
    >
      Skip to main content
    </a>
  );
};
